import { graphql, useStaticQuery } from "gatsby";

const useBurgerMenu = () => {
  const data = useStaticQuery(graphql`
    query {
      allStrapiBurgerMenu(filter: {publish: {eq: true}}, sort: {sort: ASC}) {
        edges {
          node {
            title
            link {
              ...MenuFragment
            }
          }
        }
      }
    }
  `);
  const { edges: header_menu_edges } = data?.allStrapiBurgerMenu;
  return {
    menu_data: header_menu_edges
  };
};

export default useBurgerMenu;
